export default "select database_id, schema_id, view_id, owner_id, name\nfrom sys.view\nwhere database_id = $(database_id)\n"